<template>
  <div id="sched_box">
  <div v-if="isLoading" class="loading">Loading&#8230;</div>

<!-- <span class="has-text-link has-background-white">ABS</span>  -->
<div class="columns is-gapless is-multiline colBorderThin" style="margin-bottom:0em;">
    <div v-if="val" class="column is-2 has-text-centered has-text-weight-bold doFontSmallest underIT mt-1 isLink" :style="set_colour()"></div>
    <div v-else class="column is-2 " :style="set_colour()"></div>
    <div @mousedown="do_select()" class="column has-text-centered has-text-weight-bold is-size-7 is-10" :style="set_colour()"> {{val}} &nbsp; </div>
</div>


  </div>
</template>


<script>
import { bus } from '@/main'


export default {
    props: [ 'dt' , 'room_id' , 'time' , 'val' , 'colour', 'group_id'],
    // props: [ 'val' ],
    components: {  },
  data: function() {
    return {
        isLoading : false,
    }
  },


created() {
    
},

  methods: {




    do_select:function() {
        bus.$emit('bus_course_set', this.dt, this.room_id, this.time)
    },

    set_colour:function() {
        if (this.colour) {return 'color:white;background-color:' + this.colour }
        else {
            switch (this.time) {
                case 'AM' :
                    return 'background-color:LemonChiffon'
                    break;
                case 'PM' :
                    return 'background-color:AliceBlue'
                    break;
                default :
                    return 'background-color:LavenderBlush'
                    break;                
            }

        }
    },


  }, // END METHODS 

} // END SCRIPT
</script>




<style scoped>


</style>
